module.exports = __webpack_public_path__ + "img/avatar-36.da302cb9.png";